import api from '../../api';

const path = `/search`;

const getCompanyListRequest = params =>
    api.get(`${path}/company/get`, {
        params,
    });

export { getCompanyListRequest };
